/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'application-insights-policy';

export const applicationInsightsPolicyBreadcrumbTitle = `${prefix}.applicationInsightsPolicyBreadcrumbTitle`;

export const ENGLISH = {
    [applicationInsightsPolicyBreadcrumbTitle]: 'Application Insights Policy',
};
